export const getPartnerLogo = (name: string): string | undefined => {
  return allPartners.find((partner) => partner.name === name)?.logo;
};

export const getAirlineLogo = (name: string): string => {
  return `https://assets.odynn.com/images/Airlines/Icons/${name}_icon.jpg`;
};

export const getHotelLogo = (name: string): string => {
  return `https://assets.odynn.com/images/Hotels/Icons/${name}_icon.jpg`;
};

export const partners = [
  {
    group: 'Banks',
    partners: [
      {
        name: 'Chase Ultimate Rewards Points',
        logo: '/partners/banks/Chase.jpg'
      },
      {
        name: 'AMEX Membership Rewards Points',
        logo: '/partners/banks/AMEX.jpg'
      },
      {
        name: 'Capital One Miles',
        logo: '/partners/banks/Capital.jpg'
      },
      {
        name: 'Citi ThankYou Points',
        logo: '/partners/banks/Citi.jpg'
      }
    ]
  },
  {
    group: 'Airlines',
    partners: [
      {
        name: 'American Airlines Miles',
        logo: '/partners/airlines/AA_icon.jpg'
      },
      {
        name: 'United MileagePlus',
        logo: '/partners/airlines/UA_icon.jpg'
      },
      {
        name: 'Delta SkyMiles',
        logo: '/partners/airlines/DL_icon.jpg'
      },
      {
        name: 'SouthWest RapidRewards',
        logo: '/partners/airlines/SW_icon.png'
      }
    ]
  },
  {
    group: 'Hotels',
    partners: [
      {
        name: 'Marriott Rewards',
        logo: '/partners/hotels/Marriott_icon.jpg'
      },
      {
        name: 'Hilton Honors Points',
        logo: '/partners/hotels/Hilton_icon.jpg'
      },
      {
        name: 'Hyatt Rewards',
        logo: '/partners/hotels/Hyatt_icon.jpg'
      },
      {
        name: 'IHG Rewards Club',
        logo: '/partners/hotels/IHG_icon.jpg'
      }
    ]
  }
];

const allPartners = [
  // Banks
  {
    name: 'Chase Ultimate Rewards Points',
    logo: '/partners/banks/Chase.jpg'
  },
  {
    name: 'AMEX Membership Rewards Points',
    logo: '/partners/banks/AMEX.jpg'
  },
  {
    name: 'Capital One Miles',
    logo: '/partners/banks/Capital.jpg'
  },
  {
    name: 'Citi ThankYou Points',
    logo: '/partners/banks/Citi.jpg'
  },
  // Airlines
  {
    name: 'American Airlines Miles',
    logo: '/partners/airlines/AA_icon.jpg'
  },
  {
    name: 'United MileagePlus',
    logo: '/partners/airlines/UA_icon.jpg'
  },
  {
    name: 'Delta SkyMiles',
    logo: '/partners/airlines/DL_icon.jpg'
  },
  {
    name: 'SouthWest RapidRewards',
    logo: '/partners/airlines/SW_icon.png'
  },
  {
    name: 'Virgin Atlantic',
    logo: '/partners/airlines/VS_icon.jpg'
  },
  {
    name: 'Aeroplan Miles',
    logo: '/partners/airlines/AC_icon.jpg'
  },
  {
    name: 'BA Avios',
    logo: '/partners/airlines/BA_icon.jpg'
  },
  {
    name: 'Flying Blue Miles',
    logo: '/partners/airlines/AF_icon.jpg'
  },
  {
    name: 'Alaska Airlines Miles',
    logo: '/partners/airlines/AS_icon.jpg'
  },
  {
    name: 'British Airways',
    logo: '/partners/airlines/BA_icon.jpg'
  },
  {
    name: 'Cathay Pacific',
    logo: '/partners/airlines/CX_icon.jpg'
  },
  {
    name: 'Emirates',
    logo: '/partners/airlines/EK_icon.jpg'
  },
  {
    name: 'Hawaiian Airlines',
    logo: '/partners/airlines/HA_icon.jpg'
  },
  //Hotels
  {
    name: 'Marriott Rewards',
    logo: '/partners/hotels/Marriott_icon.jpg'
  },
  {
    name: 'Hilton Honors Points',
    logo: '/partners/hotels/Hilton_icon.jpg'
  },
  {
    name: 'Hyatt Rewards',
    logo: '/partners/hotels/Hyatt_icon.jpg'
  },
  {
    name: 'IHG Rewards Club',
    logo: '/partners/hotels/IHG_icon.jpg'
  },
  {
    name: 'Choice Privileges',
    logo: '/partners/hotels/Choice_icon.jpg'
  },
  {
    name: 'Wyndham Rewards',
    logo: '/partners/hotels/Wyndham_icon.jpg'
  },
  {
    name: 'Accor Live Limitless',
    logo: '/partners/hotels/Accor_icon.jpg'
  },
  {
    name: 'Radisson Rewards',
    logo: '/partners/hotels/Radisson_icon.jpg'
  }
];
